import { useEffect } from 'react';

const MOBILE_MODAL_MQ = '(max-width: 767.98px)';

/** 全屏订单 Modal：修正 iOS 滚动偏移与 RB 滚动条补偿导致的左右 padding */
export function useOrderFullscreenModalLayoutFix(isOpen) {
	useEffect(() => {
		if (!isOpen || typeof window === 'undefined') {
			return undefined;
		}

		const isMobile = window.matchMedia(MOBILE_MODAL_MQ).matches;
		const scrollY = window.scrollY;
		const body = document.body;
		const prevBody = {
			position: body.style.position,
			top: body.style.top,
			left: body.style.left,
			right: body.style.right,
			width: body.style.width,
		};

		if (isMobile && scrollY > 0) {
			body.style.position = 'fixed';
			body.style.top = `-${scrollY}px`;
			body.style.left = '0';
			body.style.right = '0';
			body.style.width = '100%';
		}

		const applyModalFix = () => {
			document.querySelectorAll('.order-fullscreen-modal.show').forEach((modalEl) => {
				modalEl.style.paddingLeft = '0px';
				modalEl.style.paddingRight = '0px';
				modalEl.style.overflow = 'hidden';

				const dialog = modalEl.querySelector('.modal-dialog.modal-fullscreen');
				if (dialog) {
					dialog.style.margin = '0';
					dialog.style.transform = 'none';
				}
			});
		};

		applyModalFix();
		const rafId = requestAnimationFrame(applyModalFix);
		const timerId = window.setTimeout(applyModalFix, 60);
		window.addEventListener('resize', applyModalFix);

		return () => {
			cancelAnimationFrame(rafId);
			window.clearTimeout(timerId);
			window.removeEventListener('resize', applyModalFix);

			body.style.position = prevBody.position;
			body.style.top = prevBody.top;
			body.style.left = prevBody.left;
			body.style.right = prevBody.right;
			body.style.width = prevBody.width;

			if (isMobile && scrollY > 0) {
				window.scrollTo(0, scrollY);
			}
		};
	}, [isOpen]);
}
